export const APP_NAME = 'Findex Admin';
export const IMPORT_BATCH_SIZE = 200;
export const QUERY_PAGE_SIZE = 50;
export const RELEASE_SCHEMA_VERSION = 2;
export const STORE_ALL_IMPORT_ROWS = false;

export const CONTENT_BUCKET =
  import.meta.env.VITE_CONTENT_BUCKET?.trim() || 'findex-content';
export const ADMIN_BUCKET =
  import.meta.env.VITE_ADMIN_BUCKET?.trim() || 'findex-admin';

export const RIDDLE_STATUSES = [
  'draft',
  'needs_review',
  'approved',
  'declined',
  'published',
  'disabled',
  'archived',
] as const;
